import { CommentPanelStatus } from "components/common/comments/interface";
import { eHierarchyLevel } from "functions/api/enums";
import { cloneDeep } from "lodash";
import { getHierarchyPrefix } from "./getHierarchyPrefix";
import { hcr_buildParentTemplates } from "./hcr_buildParentTemplates";
import { HierarchyContextProps, IHierarchyActionLoadHierarchy } from "./interface";

/**
 * Loads hierarchy data into the context state and builds parent templates.
 *
 * @param action - The action containing the hierarchy and parent nodes to load
 * @param state - The current hierarchy context state
 * @returns Updated hierarchy context state with loaded hierarchy and templates
 */
export const hcr_loadHierarchy = (
  action: IHierarchyActionLoadHierarchy,
  state: HierarchyContextProps,
): HierarchyContextProps => {
  // Update parent hierarchy information
  const hierarchyNodes = [
    ...state.hierarchyNodes.filter(
      (h) => ![...action.hierarchyNodes!.map((h) => h.id), action.hierarchy!.id].includes(h.id),
    ),
    action.hierarchy,
    ...action.hierarchyNodes.filter((h) => h.level !== eHierarchyLevel.TopLevel),
  ];

  // Build parent templates from parent hierarchy nodes
  const parentTemplates = hcr_buildParentTemplates(action.hierarchy, hierarchyNodes);

  // Reset Comment Panel Status for initial load if needed
  const commentPanelStatus: CommentPanelStatus = state.commentPanelStatus.showComments
    ? {
        showComments: false,
        highlightCommentId: "",
        activeRelatedTo: "",
        commentFilter: "all",
      }
    : state.commentPanelStatus;

  return {
    ...state,
    changed: false,
    id: action.hierarchy.id,
    hierarchy: action.hierarchy,
    savedHierarchy: cloneDeep(action.hierarchy),
    prefix: getHierarchyPrefix(action.hierarchy.level),
    hierarchyNodes,
    parentTemplates,
    accessRights: action.accessRights,
    tlfItemIndex: action.hierarchy.id === state.hierarchy?.id ? state.tlfItemIndex : null,
    isSubscribed: action.isSubscribed,
    commentPanelStatus,
  };
};
